export interface IBase64 {
  decode: (input: string) => string;
  encode: (input: string) => string;
}

/**
 * Browser-compatible Base64 encoder/decoder using btoa/atob.
 * This is safe to use in web workers and browser contexts.
 */
export const Base64: IBase64 = {
  /**
   * Base64 decode a string using browser's atob function.
   * @param str - The string to decode.
   */
  decode(str: string): string {
    const decoded = atob(str);
    let result = '';
    for (let i = 0; i < decoded.length; i++) {
      const hex = ('00' + decoded.charCodeAt(i).toString(16)).slice(-2);
      result += '%' + hex;
    }
    return decodeURIComponent(result);
  },
  /**
   * Base64 encode a string using browser's btoa function.
   * @param str - The string to encode.
   */
  encode(str: string): string {
    return btoa(
      encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (_, p1) => {
        return String.fromCharCode(parseInt(p1, 16));
      })
    );
  }
};
